import React from "react";
import PropTypes from "prop-types";
import GenericNavigation from "components/GenericNavigation";
import ProviderNavigation from "components/ProviderNavigation";
import CustomerNavigation from "components/CustomerNavigation";
import AdminNavigation from "components/AdminNavigation";
import useVendorUser from "hooks/use-vendor-user";
import useCustomerUser from "hooks/use-customer-user";
import useAdminUser from "hooks/use-admin-user";

export default function ConditionalNavWrapper({ children }) {
  const providerUser = useVendorUser();
  const customerUser = useCustomerUser();
  const adminUser = useAdminUser();

  if (providerUser) {
    return <ProviderNavigation>{children}</ProviderNavigation>;
  }
  if (customerUser) {
    return <CustomerNavigation>{children}</CustomerNavigation>;
  }
  if (adminUser) {
    return <AdminNavigation>{children}</AdminNavigation>;
  }
  return <GenericNavigation>{children}</GenericNavigation>;
}

ConditionalNavWrapper.propTypes = {
  children: PropTypes.any.isRequired,
};
